<template>
  <div>
    <div class="form-row div-valign" v-for="item of lgSpecificFields" v-bind:key="item.seq">
      <div class="form-group col-md-12" v-if="item.dataType == 'string'">
        <label>{{ item.label }}</label
        ><span class="required" v-if="item.required == 'Y'">*</span>
        <input
          v-model="formData[item.fieldName]"
          :name="item.fieldName"
          :ref="item.fieldName"
          :data-vv-as="item.fieldName"
          v-validate="{ required: item.required === 'Y' }"
          :disabled="isDisabled(item.fieldName)"
          :class="{ input: true, 'is-danger': errors.has(item.fieldName) }"
          :maxlength="item.maxLength"
          @blur="gethospitalName(item.fieldName)"
          @keypress="isNumber($event, item.fieldName, item.dataType)"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has(item.fieldName)" class="help is-danger">กรุณากรอก {{ item.label }}</span>
      </div>
      <div class="form-group col-md-6" v-if="item.dataType == 'date'">
        <label>{{ item.label }}</label><span class="required" v-if="item.required == 'Y'">*</span>
        <span class="text-white" v-if="item.fieldName.length < 17">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <date-picker
          v-model="formData[item.fieldName]"
          :name="item.fieldName"
          :data-vv-as="item.fieldName"
          :ref="item.fieldName"
          format="DD/MM/YYYY"
          v-validate="{ required: item.required === 'Y' }"
          :disabled="isDisabled(item.fieldName)"
          lang="th"
          :class="{ input: true, 'is-danger': errors.has(item.fieldName) }"
          placeholder
        ></date-picker>
        <span v-show="errors.has(item.fieldName)" class="help is-danger">กรุณากรอก {{ item.label }}</span>
      </div>
      <div class="form-group col-md-12" v-if="item.dataType == 'number'">
        <label>{{ item.label }}</label><span class="required" v-if="item.required == 'Y'">*</span>
        <vue-numeric
          separator=","
          v-model="formData[item.fieldName]"
          :name="item.fieldName"
          class="form-control"
          :ref="item.fieldName"
          v-bind:precision="2"
          v-validate="{
            required: item.required === 'Y',
            min_value: 0.01,
            max_value:
              item.fieldName == 'percentage'
                ? 100.0
                : 9999999999999999999999.99,
          }"
          :disabled="isDisabled(item.fieldName)"
          :maxlength="item.maxLength"
          @keypress="isNumber($event,item.fieldName,item.dataType)"
          @blur="validPercent()"
          :class="{ input: true, 'is-danger': errors.has(item.fieldName) }"></vue-numeric>
        <span v-show="errors.has(item.fieldName)" v-if="item.fieldName == 'percentage'" class="help is-danger">กรุณากรอก {{ item.label }}</span>
        <span v-show="errors.has(item.fieldName)" v-if="item.fieldName != 'percentage'" class="help is-danger">{{ item.label }} ต้องมีค่ามากกว่า 0</span>
      </div>
      <div class="form-group col-md-12" v-if="item.dataType == 'option'">
        <label>{{ item.label }}</label><span class="required" v-if="item.required == 'Y'">*</span>
        <select
          v-model="formData[item.fieldName]"
          :name="item.fieldName"
          :ref="item.fieldName"
          class="form-control"
          :disabled="isDisabled(item.fieldName)"
          v-validate="{ required: item.required === 'Y' }"
          :class="{ input: true, 'is-danger': errors.has(item.fieldName) }"
          @change="onChangeContractType($event)"
        >
          <option value="">กรุณาเลือก</option>
          <option
            v-for="option in contractTypeList"
            :value="option.contractTypeId"
            :key="option.contractTypeId"
            >{{ option.contractTypeDesc }}</option
          >
        </select>
        <span v-show="errors.has(item.fieldName)" class="help is-danger">กรุณากรอก {{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import moment from "moment";
import { apiClient } from "@/utils/apiClient";

export default {
  inject: ["$validator"],
  props: ["reqType", "appVo", "lgType", "lgFormNo", "beneGroup", "beneTaxId"],
  components: {
    DatePicker,
  },
  data() {
    return {
      specificVo: [],
      lgSpecificFields: [],
      formData: {},
      contractTypeList: [],
      modifyFlag: ""
    };
  },
  mounted() {
    this.$nextTick(() => {
      if(  this.beneGroup !== "" &&
        this.lgType !== "" &&
        this.lgFormNo !== "" &&
        this.beneTaxId !== ""){
          this.getLgSpecificField();
      }
     
    });
  },
  watch: {
    formData: {
      handler(newValue) {
        this.$emit('childToParent', newValue);
      },
      deep: true
    }
  },
  methods: {
    onChangeContractType(event){
      const contractTypeId = event.target.value;
      if(contractTypeId) {
        const item = this.contractTypeList.find(contract => contract.contractTypeId == contractTypeId);
        this.formData["contractTypeDesc"] = item.contractTypeDesc;
      }
    },
    getValueByKey(object, value) {
      // วน loop ทุก key ใน object
      for (let key in object) {
        // เช็คว่า key ใน object เท่ากับ value ที่เราต้องการหาหรือไม่
        if (key === value) {
          // ถ้าตรงกัน คืนค่า value ของ key นั้นออกมา
          return object[key];
        }
      }
      // ถ้าไม่มี key คืนค่า null
      return null;
    },
    isDisabled(fieldName) {
      if(this.beneGroup){
        if (fieldName == 'hospitalName' || fieldName == 'contractTypeId') {
          return true;
        } else if (fieldName == 'beneficiaryRemark') {
          return (
            this.reqType !== 1 &&
            this.modifyFlag !== "Y" &&
            this.specificVo.beneGroup !== "NHSO"
          );
        } else if (fieldName == 'securityNo') {
          return this.reqType !== 1 && this.appVo.bcFlag !== '1' && this.modifyFlag !== "Y";
        } else {
          return this.reqType !== 1 && this.modifyFlag !== "Y";
        }
      }
      
    },
    gethospitalName(fieldName) {
      if (fieldName == 'hospitalCode') {
        this.loader = this.$loading.show();
        this.formData["hospitalName"] = "";
        apiClient
          .get(
            "/api/home/getHospitalName/" +
              this.formData["hospitalCode"]
          )
          .then((res) => {
            this.loader.hide();
            if (res && res.data) {
              this.formData["hospitalName"] = res.data.hospitalName;
            } else {
              this.formData["hospihospitalCodetalName"] = "";
              this.$swal(
                "Error",
                "ไม่พบข้อมูลสถานบริการ กรุณาตรวจสอบรหัสสถานบริการ",
                "error"
              );
              return;
            }
          })
          .catch((error) => {
            if(error.response.status===401){
                this.loader.hide();
            }
          });
      }
    },
    getContractTypeList() {
      this.contractTypeList = [];
      apiClient
        .get("/api/home/getContractTypeList")
        .then((resp) => {
          if (resp && resp.data) {
            this.contractTypeList = resp.data;
            if (
              this.formData["contractTypeId"] &&
              this.formData["contractTypeDesc"]
            ) {
              // this.formData["contractTypeId"] = {
              //   contractTypeId: this.formData["contractTypeId"],
              //   contractTypeDesc: this.formData["contractTypeDesc"],
              // };
            } else {
              this.formData["contractTypeId"] = resp.data[0].contractTypeId;
              this.$set(this.formData, 'contractTypeDesc', resp.data[0].contractTypeDesc);
            }
          }
        })
        .catch((error) => {
          if(error.response.status===401){
                this.loader.hide();
          }
        });
    },
    async getLgSpecificField() {
      if (this.lgFormNo !== "" && this.beneTaxId !== "") {
        apiClient
          .get(
            "/api/home/getLgSpecificField/" +
              this.beneTaxId +
              "/" +
              this.lgFormNo
          )
          .then((resp) => {
            this.lgSpecificFields = resp.data;
            this.lgSpecificFields.forEach((field) => {
              // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
              if (this.appVo) {
                const key = field.fieldName;
                let value = this.getValueByKey(this.appVo, key);
                if (value !== null) {
                  
                  if (field.dataType == "date") {
                    if(value.length == 8){ // YYYYMMDD
                      const regex = /^(\d{4})(\d{2})(\d{2})$/;
                      const match = value.match(regex);
                      if (match) {
                        // DD/MM/YYYY
                        value = `${match[3]}/${match[2]}/${match[1]}`;
                      } 
                    }
                    this.$set(
                      this.formData,
                      field.fieldName,
                      moment(value, "DD/MM/YYYY")
                    );
                  } else {
                    if (field.fieldName == "contractTypeId") {
                      if (this.beneGroup === "NHSO") {
                        this.getContractTypeList();
                        this.$set(this.formData, field.fieldName, value);
                      }
                    } else {
                       this.$set(this.formData, field.fieldName, value);
                    }
                   
                  }
                }
                this.modifyFlag = this.appVo.modifyFlag;
              } else {
                if (this.beneGroup === "MU") {
                  if (field.fieldName == "projectOwner") {
                    this.$set(
                      this.formData,
                      field.fieldName,
                      "คณะแพทยศาสตร์โรงพยาบาลรามาธิบดี"
                    );
                  } else {
                    this.$set(this.formData, field.fieldName, "");
                  }
                } else {
                  this.$set(this.formData, field.fieldName, "");
                  if (this.beneGroup === "NHSO") {
                    this.getContractTypeList();
                  }
                }
              }
            });
          })
          .catch((error) => {
            if(error.response.status===401){
                this.loader.hide();
            }
          });
      }
    },
    isNumber: function(evt, fieldName, dataType) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if(dataType == 'string'){
        if(this.beneGroup == 'PEA'){
          if(fieldName == 'caNo' || fieldName == 'securityNo' || fieldName == 'bpNo'){
            if (
              charCode > 31 &&
              (charCode < 48 || charCode > 57) &&
              charCode !== 46
            ) {
              evt.preventDefault();
            } else {
              return true;
            } 
          }
        } else {
          return true;
        }
      } else {
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        } else {
          return true;
        } 
      }
    },
    isKeypress: function(evt) {
      evt = evt ? evt : window.event;
      evt.preventDefault();
    },
    validPercent() {
      if (this.formData["percentage"]) {
        if (100 < this.formData["percentage"]) {
          this.formData["percentage"] = "100.00";
          this.$validator.reset("percentage");
        }
      }
    },
  },
};
</script>

<style>
.required {
  font-weight: bold;
  color: red;
  font-size: 1.5em;
}
</style>
